// Delete any uneeded properties for 'note' product
// Determine based on if product contains word 'note'
export const isNote = ({product_name}) => {
    const noteRE = /\bnote\b/i;
    return product_name ? product_name.match(noteRE) : null;
};
